function LayoutWithoutSidebar({ children, marginV = 'my-20', className = '' }) {
    return <div className={`max-w-6xl mx-auto ${marginV}     ${className} `}>{children}</div>;
}

export default LayoutWithoutSidebar;
